import React from 'react';
import Head from 'next/head';
import type { GetServerSidePropsResult } from 'next';

import Layout from '@/components/Layout';
import ResultList from '@/components/resultList/ResultList';
import { wrapper } from '@/state/store';
import { actions as filterActions } from '@/state/filterActions';
import { actions as resultActions } from '@/state/resultActions';
import { fetchOffers } from '@/api/fetcher';
import { browserQueryParamsToFilters, filtersToApiQueryParams } from '@/lib/utils/queryParamFilterConversions';
import { runAllMiddlewares } from '@/server/middleware';
import { getPageCounter } from 'shared/prometheus/prometheus';

const ResultPage = (props) => {
    wrapper.useHydration(props);

    return (
        <>
            <Head>
                <meta name="robots" content="noindex" />
            </Head>
            <Layout>
                <h1 className="u-screen-reader-only">Pakkereiser</h1>
                <ResultList />
            </Layout>
        </>
    );
};

export const getServerSideProps = wrapper.getServerSideProps(
    (store) =>
        // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        async ({ req, res, query }): Promise<GetServerSidePropsResult<any>> => {
            if (!query.skipSSRData) {
                const props = await runAllMiddlewares(req, res, query);

                const filters = browserQueryParamsToFilters(query);
                store.dispatch(filterActions.filter(filters));

                const { statusCode, data } = await fetchOffers(filtersToApiQueryParams(filters));

                if (statusCode === 200) {
                    store.dispatch(resultActions.setResults(data));
                } else {
                    store.dispatch(resultActions.setError());
                }
                getPageCounter().inc({ app: 'pp-web', page: 'result' });
                return { props: { ...props } };
            }
            return { props: {} };
        }
);

export default ResultPage;
